import type { RouteMonitoringVisit } from '@/pages/Business/pages/Monitoring/models';
import type { ShippingForRouting } from '@/pages/Business/pages/Shippings/models';
import { parseCoordFromMonitoring } from '../parse-monitoring-coord';
import {
  buildCommerce,
  buildCommerceShippingNumber,
  buildCommercialService,
  buildLogisticOperator,
  buildRecipient,
  firstShipping,
  trimMonitoringText,
  visitTypeFromStrings,
} from './monitoring-visit-field-builders';

export interface BuildShippingFromMonitoringVisitContext {
  logisticOperatorId: string;
  scheduled: string;
}

export function buildShippingForRoutingFromMonitoringVisit(
  visit: RouteMonitoringVisit,
  ctx: BuildShippingFromMonitoringVisitContext
): ShippingForRouting {
  const primary = firstShipping(visit);
  const lat = parseCoordFromMonitoring(visit.address?.lat ?? null) ?? 0;
  const long = parseCoordFromMonitoring(visit.address?.long ?? null) ?? 0;
  const commerceShippingNumber = buildCommerceShippingNumber(visit, primary);
  const recipient = buildRecipient(visit, primary);
  const commerce = buildCommerce(visit, primary);
  const commercialService = buildCommercialService(primary);
  const logisticOperator = buildLogisticOperator(primary);
  const serviceVisitTypeNameRaw = primary
    ? trimMonitoringText(primary.serviceVisitTypeName)
    : '';
  const serviceVisitTypeName = serviceVisitTypeNameRaw || undefined;
  const serviceTypeRaw = primary ? trimMonitoringText(primary.serviceType) : '';
  const serviceType = serviceTypeRaw || undefined;
  const visitType = visitTypeFromStrings(primary?.visitType);

  return {
    number: visit.shippingNumber,
    recipient,
    recipientPhoneNumber: '',
    commerceShippingNumber,
    destinationAddress: visit.address
      ? {
          streetName: visit.address.streetName ?? '',
          doorNumber: visit.address.doorNumber ?? '',
          apartmentNumber: visit.address.apartmentNumber ?? null,
          lat,
          long,
        }
      : null,
    originAddress: null,
    commerce,
    commercialService,
    status: null,
    dateToDelivery: ctx.scheduled,
    timeWindowStart: visit.scheduledFrom,
    timeWindowEnd: visit.scheduledTo,
    logisticOperatorId: ctx.logisticOperatorId || undefined,
    visitType,
    serviceVisitTypeName,
    serviceType,
    logisticOperator,
  };
}
